import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import { Link } from 'react-router-dom';
import coupleKitchen from "../media/img/backgrounds/couple-kitchen.jpg";
import womanChair from "../media/img/backgrounds/woman-chair.jpg";
import americanExpress from "../media/img/payments/american-express.png";
import bankAccount from "../media/img/payments/bank-account.png";
import discover from "../media/img/payments/discover.png";
import mastercard from "../media/img/payments/mastercard.png";
import unionPay from "../media/img/payments/unionpay.png";
import visa from "../media/img/payments/visa.png";
import Letus from "./common/Propertii";
import Spinner from "./common/Spinner";

class Home extends Letus {

    /**
     * Render the component.
     *
     * @returns {*} - The homepage component.
     */
    render() {
        const language = this.props.intl.locale === 'fr' ? '-fr': '';
        return(
            <div className="content-block">

                <Spinner visible={this.state.spinner}/>

                <div id="signup" className="jumbotron jumbotron-fluid content-header content-header-landing mb-0" style={{background: `linear-gradient(100deg, rgb(79, 79, 79) 0%, rgba(17, 17, 17, 0.1) 100%) 0% 0% / cover, url('${coupleKitchen}') no-repeat center center scroll`, backgroundSize: "cover"}}>
                    <div className="container">

                        <div className="row align-items-center">
                            <div className="col-md-8 align-self-center">

                                <h1 className="text-white mb-4 display-4">
                                    <FormattedMessage
                                        id='home.header.title.better-renting'
                                        defaultMessage='Open your door to better renting'
                                    />
                                </h1>
                                <p className="lead text-white mb-4">
                                    <FormattedMessage
                                        id='home.header.subtitle.rental-experience'
                                        defaultMessage='Letus gives property managers the tools they need to create a better rental experience.'
                                    />
                                </p>

                                <div className="mb-4">
                                    <Link to="/landlords" className="btn btn-primary btn-lg mb-2 mr-2">
                                        <FormattedMessage
                                            id='home.body.sec-3.action-1.i-pm'
                                            defaultMessage='I am a Property Manager'
                                        />
                                    </Link>
                                    <Link to="/tenants" className="btn btn-primary btn-lg mb-2 mr-2">
                                        <FormattedMessage
                                            id='home.body.sec-3.action-2.i-tenant'
                                            defaultMessage='I am a Tenant'
                                        />
                                    </Link>
                                    {/* <Link to="/selfsignup/letus" className="btn btn-outline-primary btn-lg mb-2 btn-lease-signup">
                                        Sign Up for Lease
                                    </Link> */}
                                </div>
                            </div>
                            <div className="col-md-4">
                            </div>
                        </div>

                    </div>
                </div>

                <div className="container">

                    <div className="row">
                        <div className="col-md-6 align-self-center">
                            <h1 className="mb-4">
                                <FormattedMessage
                                    id='home.body.sec-1.title.prop-management-sol'
                                    defaultMessage='The simple and secure property management solution'
                                />
                            </h1>
                            <p className="mb-4 lead">
                                <FormattedMessage
                                    id='home.body.sec-1.description.cover-everything'
                                    defaultMessage='Letus has you covered from the moment a lease application is submitted to the day rent is due, and everything in between.'
                                />
                            </p>
                            <Link to="/landlords" className="btn btn-outline-primary btn-lg mb-2">
                                <FormattedMessage
                                    id='common.button.learn-more'
                                    defaultMessage='Learn More.'
                                />
                            </Link>
                        </div>
                        <div className="col-md-6">
                            <img src={require(`../media/img/mockups/property-management${language}.png`)} alt="Letus offers a wide variety of simple and secure property management tools for landlords" className="img-sm-fluid" width="130%"/>
                        </div>
                    </div>

                    <hr className="my-5" id="screenings" />

                    <div className="row">
                        <div className="col-md-6 order-md-2 align-self-center">
                            <h1 className="mb-4">
                                <FormattedMessage
                                    id='home.body.sec-2.title.rent-reward'
                                    defaultMessage='Making rent payments rewarding for tenants'
                                />
                            </h1>
                            <p className="mb-4 lead">
                                <FormattedMessage
                                    id='home.body.sec-2.description.enjoy-flexibility'
                                    defaultMessage='Enjoy the flexibility and convenience of paying your rent online, all while building up your credit and earning points on your rewards credit card.'
                                />
                            </p>
                            <div className="mb-4">
                                <img src={visa} className="rounded img-fluid bg-light border mr-2" alt="Visa" title="Visa" width="50"/>
                                <img src={mastercard} className="rounded img-fluid bg-light border mr-2" alt="Mastercard" title="Mastercard" width="50"/>
                                <img src={americanExpress} className="rounded img-fluid bg-light border mr-2" alt="American Express" title="American Express" width="50"/>
                                <img src={discover} className="rounded img-fluid bg-light border mr-2" alt="Discover" title="Discover" width="50"/>
                                <img src={unionPay} className="rounded img-fluid bg-light border mr-2" alt="UnionPay" title="UnionPay" width="50"/>
                                <img src={bankAccount} className="rounded img-fluid bg-light border mr-2" alt="Bank Account" title="Bank Account" width="50"/>
                            </div>
                            <Link to="/tenants" className="btn btn-outline-primary btn-lg mb-2">
                                <FormattedMessage
                                    id='common.button.learn-more'
                                    defaultMessage='Learn More.'
                                />
                            </Link>
                        </div>
                        <div className="col-md-6 order-md-1">
                            <img src={require(`../media/img/mockups/payment-flow${language}.png`)} alt="Letus offers simple and secure online rent payments for tenants" className="img-sm-fluid float-right" width="130%"/>
                        </div>
                    </div>

                </div>

                <div className="jumbotron jumbotron-fluid mb-0" style={{background: `linear-gradient(20deg, rgb(79, 79, 79) 0%, rgba(17, 17, 17, 0.38) 100%) 0% 0% / cover, url('${womanChair}') no-repeat center center scroll`, backgroundSize: "cover"}}>
                    <div className="container text-center">
                        <h1 className="pt-4 mb-4 text-white">
                            <FormattedMessage
                                id='common.title.better-rental'
                                defaultMessage='A better rental experience begins with Letus'
                            />
                        </h1>
                        <div className="row justify-content-md-center">
                            <div className="col-md-8 text-md-center">
                                <p className="lead text-white">
                                    <FormattedMessage
                                        id='common.description.trusted-america'
                                        defaultMessage="Trusted by North America's biggest property managers, now available to you. Start by creating your Letus account today."
                                    />
                                </p>
                            </div>
                        </div>
                        <div className="">
                            <Link to="/landlords" className="btn btn-primary btn-lg mb-4 mr-2">
                                <FormattedMessage
                                    id='home.body.sec-3.action-1.i-pm'
                                    defaultMessage='I am a Property Manager'
                                />
                            </Link>
                            <Link to="/tenants" className="btn btn-primary btn-lg mb-4">
                                <FormattedMessage
                                    id='home.body.sec-3.action-2.i-tenant'
                                    defaultMessage='I am a Tenant'
                                />
                            </Link>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

Home.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Home);
